import type { ExecutionsHistoryQuery } from '@src/models/interfaces/executionsHistoryDashboard.interface';

import {
  getTemplateIdsForApi,
  type TasksChartFilters,
} from '../tasksFilterConfig';
import { getTasksReportCalendarRange } from '../utils/reportPeriod';

/**
 * Shared section filters for the execution history operation, from the report filters.
 * Re-clamps to the 3-month span regardless of the caller: `filters` may still be the shared
 * SecondaryPanel's value from a sibling dashboard without this cap.
 */
export const buildHistoryQuery = (
  filters: TasksChartFilters,
  organizationId: string,
  divisionIds: string[],
  timeZone?: string,
): ExecutionsHistoryQuery => {
  return {
    organizationId,
    divisionIds,
    templateIds: getTemplateIdsForApi(filters.templates),
    range: getTasksReportCalendarRange(filters, timeZone),
    interval: filters.groupBy,
    ...(filters.costCenterIds?.length ? { costCenterIds: filters.costCenterIds } : {}),
  };
};
